import Class from '@/Class';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';
import Utilities from '@/Utility/Utilities';

export default class ViewModel extends Class {

    /** 
     * Locator des Parents
     */
    public parentLocator: KnockoutObservable<string>;

    /** 
     * Ein eindeutiger Name zur Identifikation im DOM
     */
    public locator: KnockoutComputed<string>;

    private internalLocator: KnockoutObservable<string>;

    public constructor(params: CoreFrameInterfaces.IViewModelConstructorParameter) {
        super();

        this.parentLocator = this.observableOrDefault(params.parentLocator, '');

        this.internalLocator = this.observableOrDefault(params.locator, '');

        this.locator = this.defineComputed({
            read: () => {
                let parentLocator = this.parentLocator();
                let locator = this.internalLocator();
                let newLocator = null;

                if (!Utilities.isNullOrUndefined(parentLocator) && Utilities.isNotBlank(parentLocator))
                    newLocator = parentLocator;

                if (locator) {
                    if (newLocator)
                        newLocator = ViewModel.mergeLocator(parentLocator, locator);
                    else
                        newLocator = locator;

                    return newLocator;
                }

                return null;
            },
            write: (value) => {
                this.internalLocator(value);
            }
        });
    }

    public static mergeLocator(parent: string, child: string): string {
        let parents = parent.split('.');
        let children = child.split('.');

        let bestResult = -1;
        let bestResultIndex = null;

        let actualResult = 0;

        outer:
        for (let i = parents.length - 1; i >= 0; i--) {
            for (let j = 0; j < children.length; j++) {

                if (children[j] != parents[(i + j)]) {
                    if (actualResult >= bestResult) {
                        bestResult = actualResult;
                        bestResultIndex = j;
                    }

                    if (parents[(i + j)] === undefined) {
                        break outer;
                    }

                    actualResult = 0;
                    break;
                }
                actualResult++;

            }
        }

        for (let i = bestResultIndex; i < children.length; i++) {
            parents.push(children[i]);
        }
        return parents.join('.');
    }
}